export default __webpack_public_path__ + "static/media/112.57a369d7.png";